import React, { Component } from "react";
import { Container, Row, Col, Card, ListGroup } from "react-bootstrap";

/**
 * Beautifully formatted sequential conversation list with role-based colors and timestamps.
 */
export default class AiChatTranscript extends Component {
  static defaultProps = {
    title: "Chat Transcript",
    dataString: "[{\"role\":\"system\",\"content\":\"Call connected. Starting Node.js focused conversation.\",\"timestamp\":1762343500783},{\"role\":\"system\",\"content\":\"AI assistant connected - Node.js conversation ready\",\"timestamp\":1762343502072},{\"role\":\"assistant\",\"content\":\"Dummy welcome prompt\",\"timestamp\":1762343502072},{\"role\":\"assistant\",\"content\":\"Hello! How can I help you today?\",\"timestamp\":1762343504119},{\"role\":\"assistant\",\"content\":\"I'm here to help! What do you need assistance with?\",\"timestamp\":1762343511630},{\"role\":\"user\",\"content\":\"Don't tell me\",\"timestamp\":1762343511725},{\"role\":\"system\",\"content\":\"Call ended\",\"timestamp\":1762343514674}]",
  };

  constructor(props) {
    super(props);
    this.state = { messages: [], error: null };
  }

  componentDidMount() {
    this.parseData(this.props.dataString);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dataString !== this.props.dataString) {
      this.parseData(this.props.dataString);
    }
  }

  parseData = (dataString) => {
    try {
      const parsed = typeof dataString === 'string' ? JSON.parse(dataString) : dataString;
      const messages = Array.isArray(parsed)
        ? parsed.sort((a, b) => a.timestamp - b.timestamp)
        : [];
      this.setState({ messages, error: null });
    } catch {
      this.setState({ error: "Invalid JSON data", messages: [] });
    }
  };

  bgStyle(role) {
    const styles = {
      system: { backgroundColor: "#fff8e1", borderLeft: "4px solid #ffca28" }, // yellow
      assistant: { backgroundColor: "#e3f2fd", borderLeft: "4px solid #42a5f5" }, // blue
      user: { backgroundColor: "#e8f5e9", borderLeft: "4px solid #66bb6a" }, // green
      default: { backgroundColor: "#f9f9f9", borderLeft: "4px solid #ccc" },
    };
    return styles[role] || styles.default;
  }

  formatTime(timestamp) {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    return date.toLocaleString();
  }

  render() {
    const { messages, error } = this.state;
    const { title } = this.props;

    return (
      <Container className="py-4">
        <Row className="justify-content-center">
          <Col lg={12}>
            <Card className="shadow border-0">
              <Card.Header className="bg-dark text-white text-center rounded-top">
                <h5 className="mb-0">{title}</h5>
              </Card.Header>
              <Card.Body className="bg-light" style={{ maxHeight: "70vh", overflowY: "auto" }}>
                {error ? (
                  <div className="text-danger small text-center py-2">{error}</div>
                ) : messages.length ? (
                  <ListGroup variant="flush">
                    {messages.map((msg, i) => (
                      <ListGroup.Item
                        key={i}
                        className="shadow-sm mb-3 border-0 px-3 py-2"
                        style={{ ...this.bgStyle(msg.role), borderRadius: "8px" }}
                      >
                        <div className="d-flex justify-content-between align-items-center mb-1">
                          <span className="fw-bold text-capitalize">{msg.role}</span>
                          <small className="text-muted" style={{fontSize: '11px'}}>{this.formatTime(msg.timestamp)}</small>
                        </div>
                        <div style={{ whiteSpace: "pre-wrap", fontSize: '12px' }}>{msg.content}</div>
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                ) : (
                  <div className="text-muted text-center py-4 small">No messages found</div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}
